import { Router } from '@angular/router';
import { driver, DriveStep } from 'driver.js';

type DriverObj = ReturnType<typeof driver>;

export function getShippingCostStarterSteps(
  router: Router,
  driverObj: DriverObj
): DriveStep[] {
  return [
    {
      element: '#menu-developer-settings',
      popover: {
        title: 'Menu API Key',
        description: 'Untuk menggunakan API Shipping Cost, pertama dapatkan API key dari menu Developer → API Key',
        side: 'right',
        align: 'start',
        popoverClass: 'custom-driver-popover hide-prev-btn',
        onNextClick: () => {
          (window as any).executeMenuDevClick();
        }
      },
      onHighlighted: () => {
        (window as any).executeMenuDevClick = () => {
          router.navigate(['/settings']).then(() => {
            let attempts = 0;
            const checkInterval = setInterval(() => {
              attempts++;

              const tabs = document.querySelectorAll('.ant-tabs-tab');
              if (tabs.length > 0) {
                const apiKeyTab = Array.from(tabs).find(t => t.textContent?.toLowerCase().includes('api key')) as HTMLElement || tabs[0] as HTMLElement;
                if (apiKeyTab && !apiKeyTab.classList.contains('ant-tabs-tab-active')) {
                  apiKeyTab.click();
                }
              }

              if (document.querySelector('#api-shipping-cost') || attempts > 30) {
                clearInterval(checkInterval);
                driverObj.moveNext();
              }
            }, 100);
          });
        };
        const el = document.querySelector('#menu-developer-settings');
        if (el) {
          (window as any).menuDevClickListener = (e: Event) => {
            (window as any).executeMenuDevClick();
          };
          el.addEventListener('click', (window as any).menuDevClickListener);
        }
      },
      onDeselected: () => {
        const el = document.querySelector('#menu-developer-settings');
        if (el && (window as any).menuDevClickListener) {
          el.removeEventListener('click', (window as any).menuDevClickListener);
          delete (window as any).menuDevClickListener;
        }
        delete (window as any).executeMenuDevClick;
      }
    },
    {
      element: '#api-shipping-cost',
      popover: {
        title: 'Tampilkan API Key',
        description: 'Klik tombol show key untuk melihat API key anda.',
        side: 'right',
        align: 'start',
        popoverClass: 'custom-driver-popover hide-prev-btn',
        onNextClick: () => {
          (window as any).handleShowKeyNextClick();
        }
      },
      onHighlighted: () => {
        const el = document.querySelector('#api-shipping-cost') as HTMLElement;
        if (el) el.style.pointerEvents = 'none';

        (window as any).executeShowKeyNext = () => {
          let attempts = 0;
          const checkInterval = setInterval(() => {
            attempts++;
            if (document.querySelector('.modal-content') || attempts > 30) {
              clearInterval(checkInterval);
              driverObj.moveNext();
            }
          }, 100);
        };

        (window as any).handleShowKeyNextClick = () => {
          if (!document.querySelector('input[formControlName="password"]')) {
            const btn = document.querySelector('#api-shipping-cost span.underline.cursor-pointer') as HTMLElement;
            if (btn) {
              btn.click();
              return;
            }
          }
          (window as any).executeShowKeyNext();
        };

        const btn = document.querySelector('#api-shipping-cost span.underline.cursor-pointer') as HTMLElement;
        if (btn) {
          btn.style.pointerEvents = 'auto';
          (window as any).handleShowKeyPhysicalClick = () => {
             (window as any).executeShowKeyNext();
          };
          btn.addEventListener('click', (window as any).handleShowKeyPhysicalClick);
        }
      },
      onDeselected: () => {
        const el = document.querySelector('#api-shipping-cost') as HTMLElement;
        if (el) el.style.pointerEvents = '';
        const btn = document.querySelector('#api-shipping-cost span.underline.cursor-pointer') as HTMLElement;
        if (btn) {
          btn.style.pointerEvents = '';
          if ((window as any).handleShowKeyPhysicalClick) {
            btn.removeEventListener('click', (window as any).handleShowKeyPhysicalClick);
            delete (window as any).handleShowKeyPhysicalClick;
          }
        }
        delete (window as any).executeShowKeyNext;
        delete (window as any).handleShowKeyNextClick;
      }
    },
    {
      element: '.modal-content',
      popover: {
        title: 'Masukkan Password',
        description: 'Isi password akun anda dan klik tombol <b>Show Key</b>.',
        side: 'bottom',
        align: 'center',
        popoverClass: 'custom-driver-popover hide-prev-btn',
        onNextClick: () => {
          const passwordInput = document.querySelector('.modal-content input[type="password"], .modal-content input[formControlName="password"]') as HTMLInputElement;
          if (passwordInput && passwordInput.value.trim()) {
            const showKeyBtn = document.querySelector('.modal-content button[type="submit"], .modal-content button.btn-primary') as HTMLElement;
            if (showKeyBtn) showKeyBtn.click();
          }
        }
      },
      onHighlighted: () => {
        const toggleNextBtn = () => {
          const passwordInput = document.querySelector('.modal-content input[type="password"], .modal-content input[formControlName="password"]') as HTMLInputElement;
          const nextBtn = document.querySelector('.driver-popover-next-btn') as HTMLButtonElement;
          if (nextBtn) {
            const hasValue = passwordInput && passwordInput.value.trim().length > 0;
            nextBtn.disabled = !hasValue;
            nextBtn.style.opacity = hasValue ? '1' : '0.5';
            nextBtn.style.cursor = hasValue ? 'pointer' : 'not-allowed';
          }
        };

        toggleNextBtn();

        (window as any).passwordInputHandler = () => toggleNextBtn();
        document.querySelector('.modal-content')?.addEventListener('input', (window as any).passwordInputHandler);

        (window as any).__passwordVerifiedForTour = false;
        (window as any).modalCheckInterval = setInterval(() => {
          if (!document.querySelector('.modal-content')) {
            clearInterval((window as any).modalCheckInterval);
            if ((window as any).__passwordVerifiedForTour) {
              driverObj.moveNext();
            } else {
              driverObj.moveTo(1);
            }
          }
        }, 200);
      },
      onDeselected: () => {
        if ((window as any).modalCheckInterval) {
          clearInterval((window as any).modalCheckInterval);
        }
        if ((window as any).passwordInputHandler) {
          document.querySelector('.modal-content')?.removeEventListener('input', (window as any).passwordInputHandler);
          delete (window as any).passwordInputHandler;
        }
      }
    },
    {
      element: '#api-shipping-cost',
      popover: {
        title: 'API key Sandbox siap digunakan',
        description: 'Sebelum kita menuju mode live, gunakan base URL dan API key Sandbox untuk testing. petunjuk teknis integrasi bisa <a href="https://rajaongkir.com/docs/shipping-cost/getting_started/about" target="_blank" class="text-primary" style="text-decoration: underline;">dibaca di sini</a>.',
        side: 'bottom',
        align: 'start',
        popoverClass: 'custom-driver-popover hide-prev-btn',
        onNextClick: () => {
          driverObj.moveNext();
        }
      },
      onHighlighted: () => {
        const row = document.querySelector('#api-shipping-cost') as HTMLElement;
        if (row) {
          const images = row.querySelectorAll('img');
          images.forEach(img => {
            img.style.pointerEvents = 'none';
            img.style.cursor = 'default';
          });
          const keySpan = row.querySelector('td:nth-child(3) span') as HTMLElement;
          if (keySpan) {
            keySpan.style.pointerEvents = 'auto';
          }
        }
      },
      onDeselected: () => {
        const row = document.querySelector('#api-shipping-cost') as HTMLElement;
        if (row) {
          const images = row.querySelectorAll('img');
          images.forEach(img => {
            img.style.pointerEvents = '';
            img.style.cursor = '';
          });
        }
      }
    },
    {
      element: '#api-shipping-cost td:last-child',
      popover: {
        title: 'Monitor penggunaan API',
        description: 'Disini anda bisa memonitor penggunaan API anda, limit untuk starter adalah 100 hit/hari, user pro 25.000 hit/hari, dan user enterprise 50.000 hit/hari.',
        side: 'bottom',
        align: 'start',
        popoverClass: 'custom-driver-popover hide-prev-btn',
        onNextClick: () => {
          driverObj.moveNext();
        }
      },
      onHighlighted: () => {
        const el = document.querySelector('#api-shipping-cost td:last-child') as HTMLElement;
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
      }
    },
    {
      element: '.ant-tabs-tab:nth-child(2)',
      popover: {
        title: 'Batasi Akses (Opsional)',
        description: 'Untuk membatasi akses API key pada IP dan platform anda saja agar lebih aman.',
        side: 'bottom',
        align: 'start',
        popoverClass: 'custom-driver-popover hide-prev-btn',
        onNextClick: () => {
          const accessTab = document.querySelectorAll('.ant-tabs-tab')[1] as HTMLElement;
          if (accessTab) accessTab.click();

          let attempts = 0;
          const checkInterval = setInterval(() => {
            attempts++;
            if (document.querySelector('app-referrer nz-card') || attempts > 30) {
              clearInterval(checkInterval);
              driverObj.moveNext();
            }
          }, 100);
        }
      }
    },
    {
      element: 'app-referrer nz-card',
      popover: {
        title: 'Batasi Akses (Opsional)',
        description: 'Bila list ini dikosongkan, maka secara default akses API key bisa digunakan dari platform manapun.',
        side: 'top',
        align: 'center',
        popoverClass: 'custom-driver-popover hide-prev-btn',
        onNextClick: () => {
          driverObj.moveNext();
        }
      },
      onHighlighted: () => {
        const el = document.querySelector('app-referrer nz-card') as HTMLElement;
        if (el) el.style.pointerEvents = 'none';

        if (!(window as any).__tourClickBlockerCard) {
          const blockInteractions = (e: Event) => {
            const target = e.target as HTMLElement;
            if (!target.closest('.driver-popover') && !target.closest('.ant-modal-root') && !target.closest('.ant-modal-wrap') && !target.closest('app-modal-end-tour')) {
              e.stopPropagation();
              e.preventDefault();
            }
          };
          document.addEventListener('click', blockInteractions, true);
          document.addEventListener('mousedown', blockInteractions, true);
          document.addEventListener('keydown', blockInteractions, true);
          (window as any).__tourClickBlockerCard = blockInteractions;
        }
      },
      onDeselected: () => {
        const el = document.querySelector('app-referrer nz-card') as HTMLElement;
        if (el) el.style.pointerEvents = '';

        if ((window as any).__tourClickBlockerCard) {
          document.removeEventListener('click', (window as any).__tourClickBlockerCard, true);
          document.removeEventListener('mousedown', (window as any).__tourClickBlockerCard, true);
          document.removeEventListener('keydown', (window as any).__tourClickBlockerCard, true);
          delete (window as any).__tourClickBlockerCard;
        }
      }
    },
    {
      popover: {
        title: '',
        description: ''
      },
      onHighlighted: () => {
        driverObj.destroy();
      }
    }
  ];

}

